import React, { useState, useEffect } from 'react';
import { FaClock } from 'react-icons/fa';

const JobTimer = ({ startTime }) => {
    const [elapsed, setElapsed] = useState(0);

    useEffect(() => {
        if (!startTime) return;

        const start = new Date(startTime).getTime();
        
        // Update immediately
        setElapsed(Math.max(0, Date.now() - start));

        const interval = setInterval(() => {
            const now = Date.now();
            setElapsed(Math.max(0, now - start));
        }, 1000);

        return () => clearInterval(interval);
    }, [startTime]);

    const formatTime = (ms) => {
        const totalSeconds = Math.floor(ms / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const pad = (n) => n.toString().padStart(2, '0');
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    };

    return (
        <div className="flex items-center bg-gray-900 text-green-400 px-4 py-2 rounded-lg font-mono text-lg font-bold shadow-inner border border-gray-700">
            <FaClock className="mr-3 animate-pulse text-green-500" />
            {formatTime(elapsed)}
        </div>
    );
};

export default JobTimer;
